import CheckCircleIcon from '../Icon/CheckCircleIcon.js';
import ChevronDownIcon from '../Icon/ChevronDownIcon.js';
import EditorCloseIcon from '../Icon/EditorCloseIcon.js';
import ErrorIcon from '../Icon/ErrorIcon.js';
import InfoIcon from '../Icon/InfoIcon.js';
import WarningIcon from '../Icon/WarningIcon.js';

//
var script = {
  name: 'Flag',
  components: {
    ChevronDownIcon,
    success: CheckCircleIcon,
    info: InfoIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    EditorCloseIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => []
    },
    appearance: {
      type: String,
      default: 'default'
    },
    type: {
      type: String,
      default: 'success'
    },
    leaveLeft: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      expanded: false
    };
  },

  computed: {
    flag() {
      switch (this.appearance) {
        case 'info':
          return {
            name: this.appearance,
            primary: '#fff',
            secondary: '#42526E'
          };

        case 'error':
          return {
            name: this.appearance,
            primary: '#fff',
            secondary: '#DE350B'
          };

        case 'warning':
          return {
            name: this.appearance,
            primary: '',
            secondary: '#FFC400'
          };

        case 'success':
          return {
            name: this.appearance,
            primary: '#fff',
            secondary: '#00875A'
          };

        default:
          return {
            name: this.type,
            primary: this.color,
            secondary: '#fff'
          };
      }
    },

    color() {
      switch (this.type) {
        case 'info':
          return '#6554c0';

        case 'error':
          return '#de350a';

        case 'warning':
          return '#ffab00';

        case 'success':
          return '#36b37e';

        default:
          return '#6554c0';
      }
    }

  },
  methods: {
    onExpand() {
      this.expanded = !this.expanded;
    },

    onClick(action) {
      if (action.href) {
        window.open(action.href, '_blank');
      }

      if (action.handler) {
        action.handler();
      }
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Flag/Flag.vue_rollup-plugin-vue=script.js